import type { TJackpotsType } from "@lobby/core/src/entities";

export const jackpotColors: Record<TJackpotsType, [string, string]> = {
  mini: ["#007ecb", "#005b95"], // lochmara, bahama-blue
  grand: ["#7052dd", "#5038a6"], // medium-purple, gigas
  major: ["#e88d23", "#cd6e00"], // fire-bush, indochine
  ultimate: ["#ff385c", "#992237"], // radical-red, mexican-red
};
